"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = "\n<div class=\"terms-index\">\n  <p>\n    <b>Classes:</b>{{#classes}} | <a href=\"{{url}}\">{{name}}</a>{{/classes}}\n  </p>\n  <p>\n    <b>Object Properties:</b>{{#relations}} | <a href=\"{{url}}\">{{name}}</a>{{/relations}}\n  </p>\n  <p>\n    <b>Dataatype Properties:</b>{{#attributes}} | <a href=\"{{url}}\">{{name}}</a>{{/attributes}}\n  </p>\n</div>\n";